import api from '../services/api'
import util from '@/helpers/util';

export default {
    namespaced: true,
    state: {
        locationTypesLoading: false,
        locationTypesLoadError: "",
        locationTypesSaving: false,
        locationTypesSaveError: "",
        locationTypes: [],

        suiteNumbersLoading: false,
        suiteNumbersLoadError: "",
        suiteNumbersSaving: false,
        suiteNumbersSaveError: "",
        suiteNumbers: [],

        roomsLoading: false,
        roomsLoadError: "",
        roomsSaving: false,
        roomsSaveError: "",
        rooms: [],

        geographicLocationsLoading: false,
        geographicLocationsLoadError: "",
        geographicLocations: [],

        drawersLoading: false,
        drawersLoadError: "",
        drawersSaving: false,
        drawersSaveError: "",
        drawers: [],
    },
  
    getters: {
        loading(state) {
            return state.locationTypesLoading || state.suiteNumbersLoading || state.roomsLoading || state.geographicLocationsLoading;
        },
        activeLocationTypes(state) {
            return state.locationTypes
                .filter(x => x.Active)
                .sort(util.sortByField("Text"));
        },
        activeSuiteNumbers(state) {
            return state.suiteNumbers
                .filter(x => x.Active)
                .sort(util.sortByField("Text"));
        },
        activeRooms(state) {
            return state.rooms
                .filter(x => x.Active)
                .sort(util.sortByField("Text"));
        },
        geographicLocations(state){
            return state.geographicLocations;
        },
        activeDrawers(state) {
            return state.drawers
                .filter(x => x.Active)
                .sort(util.sortByField("Text"));
        }
    },
  
    mutations: {
        clearSaveErrors(state) {
            state.locationTypesSaveError = "";
            state.suiteNumbersSaveError = "";
            state.roomsSaveError = "";
            state.drawersSaveError = "";
        },
        loading(state, dataType) {
            state[dataType + "Loading"] = true;
            state[dataType + "LoadError"] = "";
        },
        loadComplete(state, dataType) {
            state[dataType + "Loading"] = false;
        },
        loadError(state, data) {
            state[data.dataType] = [];
            state[data.dataType + "LoadError"] = data.error;
        },
        saving(state, dataType) {
            state[dataType + "Saving"] = true;
            state[dataType + "SaveError"] = "";
        },
        saveComplete(state, dataType) {
            state[dataType + "Saving"] = false;
        },
        saveError(state, data) {
            state[data.dataType + "SaveError"] = data.error;
        },
        clearSaveError(state, dataType) {
            state[dataType + "SaveError"] = "";
        },
        setLocationTypes(state, data) {
            state.locationTypes = data;
        },
        setSuiteNumbers(state, data) {
            state.suiteNumbers = data;
        },
        setRooms(state, data) {
            state.rooms = data;
        },
        setGeographicLocations(state, data) {
            state.geographicLocations = data;
        },
        setDrawers(state, data) {
            state.drawers = data;
        }
    },
  
    actions: {
        clearSaveErrors(context) {
            context.commit("clearSaveErrors");
        },
        
        saveLocationType(context, options) {
            context.commit("saving", "locationTypes");

            api.saveLocationType(
                options.locationType,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of location (which will include the changes we requested)
                        context.commit("setLocationTypes", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", {error: api.parseHttpRequestError(e), dataType: "locationTypes"});

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete", "locationTypes");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveSuiteNumber(context, options) {
            context.commit("saving", "suiteNumbers");

            api.saveSuiteNumber(
                options.suiteNumber,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of location (which will include the changes we requested)
                        context.commit("setSuiteNumbers", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", {error: api.parseHttpRequestError(e), dataType: "suiteNumbers"});

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete", "suiteNumbers");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveRoom(context, options) {
            context.commit("saving", "rooms");

            api.saveRoom(
                options.room,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of location (which will include the changes we requested)
                        context.commit("setRooms", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", {error: api.parseHttpRequestError(e), dataType: "rooms"});

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete", "rooms");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveDrawer(context, options) {
            context.commit("saving", "drawers");

            api.saveDrawer(
                options.drawer,
                {
                    success: function (response) {
                        // the response we get back from this function is the list of location (which will include the changes we requested)
                        context.commit("setDrawers", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function (e) {
                        context.commit("saveError", { error: api.parseHttpRequestError(e), dataType: "drawers" });

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function () {
                        context.commit("saveComplete", "drawers");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },

        loadLocationTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", "locationTypes");

                api.fetchLocationTypes({
                    success: function(response) {
                        context.commit("setLocationTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", {error: api.parseHttpRequestError(e), dataType: "locationTypes"});
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete", "locationTypes");
                    }
                });
            });
        },
        loadSuiteNumbers(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", "suiteNumbers");

                api.fetchSuiteNumbers({
                    success: function(response) {
                        context.commit("setSuiteNumbers", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", {error: api.parseHttpRequestError(e), dataType: "suiteNumbers"});
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete", "suiteNumbers");
                    }
                });
            });
        },
        loadRooms(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", "rooms");

                api.fetchRooms({
                    success: function(response) {
                        context.commit("setRooms", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", {error: api.parseHttpRequestError(e), dataType: "rooms"});
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete", "rooms");
                    }
                });
            });
        },
        loadDrawers(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", "drawers");

                api.fetchDrawers({
                    success: function (response) {
                        context.commit("setDrawers", response.data);
                        resolve();
                    },
                    error: function (e) {
                        context.commit("loadError", { error: api.parseHttpRequestError(e), dataType: "drawers" });
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function () {
                        context.commit("loadComplete", "drawers");
                    }
                });
            });
        },
        loadGeographicLocations(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", "geographicLocations");

                api.fetchGeographicLocations({
                    success: function (response) {
                        context.commit("setGeographicLocations", response.data);
                        resolve();
                    },
                    error: function (e) {
                        context.commit("loadError", { error: api.parseHttpRequestError(e), dataType: "geographicLocations" });
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function () {
                        context.commit("loadComplete", "geographicLocations");
                    }
                });
            });
        }
    }
}